import { extendTheme, theme as base } from "@chakra-ui/react";
import "./styles.css";

const theme = extendTheme({
  styles: {
    global: {
      // styles for the `body`
      body: {
        bg: "radial-gradient(50% 50% at 50% 50%, rgba(17, 10, 46, 0.76) 48.96%, #120B2F 100%)",
        color: "#FFFFFF",
        // height: "1500px"
      },
      // styles for the `p`
      p: {
        fontWeight: "700",
      },
    },
  },

  colors: {
    brand: {
      100: "#110A2E",
      200: "#FFFFFF",
      300: "#120B2F",
    },
  },

  fonts: {
    heading: `Montserrat, ${base.fonts?.heading}`,
    body: `Montserrat, ${base.fonts?.body}`,
  },

  components: {
    Button: {
      baseStyle: {
        fontWeight: "bold", // Normally, it is "semibold"
      },
      // sizes: {
      //   xl: {
      //     h: "56px",
      //     fontSize: "lg",
      //     px: "32px",
      //   },
      // },
      variants: {
        primary: {
          bg: "transparent",
          color: "brand.200",
          border: "2px solid #ffffff",
          borderRadius: "10px",
        },
        secondary: {
          bg: "linear-gradient(var(--color-bg), var(--color-bg)) padding-box,linear-gradient(to right, darkblue, darkorchid) border-box",
          color: "brand.200",
          borderRadius: "50em",
          border: "4px solid transparent",
          borderImage: " linear-gradient(180deg, #7A20AB 0%, #BB1984 100%)1",
        },
      },
    },
    NavLink: {},
  },
});

export default theme;
